import lodash from "lodash";
import { FakeLodash } from "../../lib/coreutil/FakeLodash";
export var Lockboxes;
(function (Lockboxes) {
    Lockboxes.SIZE = 5;
    let Tile;
    (function (Tile) {
        function advance(tile) {
            return (tile + 1) % 3;
        }
        Tile.advance = advance;
    })(Tile = Lockboxes.Tile || (Lockboxes.Tile = {}));
    let MoveMap;
    (function (MoveMap) {
        MoveMap.None = [
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
        ];
        MoveMap.BASIC_QUIET_PATTERNS = [
            [
                [1, 0, 0, 0, 2],
                [2, 2, 0, 1, 1],
                [1, 2, 0, 1, 2],
                [1, 1, 0, 2, 2],
                [0, 2, 0, 1, 0]
            ],
            [
                [0, 1, 0, 2, 0],
                [2, 2, 0, 1, 1],
                [2, 1, 0, 2, 1],
                [1, 1, 0, 2, 2],
                [2, 0, 0, 0, 1],
            ],
            [
                [0, 0, 1, 0, 1],
                [0, 2, 2, 1, 2],
                [1, 2, 0, 1, 2],
                [0, 1, 1, 2, 1],
                [1, 2, 2, 1, 1]
            ]
        ];
        function repeat(moves, repetition) {
            return moves.map(row => row.map(m => (m * repetition) % 3));
        }
        MoveMap.repeat = repeat;
        function get(moves, row, col) {
            if (row < 0 || row >= Lockboxes.SIZE || col < 0 || col >= Lockboxes.SIZE)
                return 0;
            else
                return moves[row][col];
        }
        MoveMap.get = get;
        function chain(...moves) {
            return MoveMap.None.map((row, row_i) => {
                return row.map((_, col_i) => {
                    return FakeLodash.sumBy(moves, m => m[row_i][col_i]) % 3;
                });
            });
        }
        MoveMap.chain = chain;
        function scoring(profile) {
            return m => FakeLodash.sum(m.flat().map(m => profile[m]));
        }
        MoveMap.scoring = scoring;
        MoveMap.clickScore = scoring([0, 1, 2]);
        MoveMap.tileScore = scoring([0, 1, 1]);
        MoveMap.hybridScore = scoring([0, 1, 1.3]);
        function isQuiet(map) {
            return State.equals(State.applyMoves(State.SOLVED, map), State.SOLVED);
        }
        MoveMap.isQuiet = isQuiet;
        let all_quiet_patterns = null;
        function allQuietPatterns() {
            if (!all_quiet_patterns) {
                // This is taken from the JS implementation at https://www.jaapsch.net/puzzles/lights.htm#java2000
                // It doesn't really match the text description there, so it might not actually be optimal
                const mults = [0, 1, 2].flatMap(a => [0, 1, 2].flatMap(b => [0, 1, 2].map(c => [a, b, c])));
                all_quiet_patterns = mults.map(([a, b, c]) => MoveMap.chain(repeat(MoveMap.BASIC_QUIET_PATTERNS[0], a), repeat(MoveMap.BASIC_QUIET_PATTERNS[1], b), repeat(MoveMap.BASIC_QUIET_PATTERNS[2], c)));
            }
            return all_quiet_patterns;
        }
        MoveMap.allQuietPatterns = allQuietPatterns;
        function getEquivalents(map) {
            return allQuietPatterns().map(quiet => chain(map, quiet));
        }
        MoveMap.getEquivalents = getEquivalents;
        function minimize(map, by = MoveMap.clickScore) {
            return FakeLodash.minBy(getEquivalents(map), by);
        }
        MoveMap.minimize = minimize;
        function fromClick(row, column) {
            return MoveMap.None.map((r, y) => r.map((_, x) => (x == column && y == row) ? 1 : 0));
        }
        MoveMap.fromClick = fromClick;
        function difference(a, b) {
            let d = 0;
            for (let y = 0; y < 5; y++) {
                for (let x = 0; x < 5; x++) {
                    if (a[x][y] != b[x][y])
                        d++;
                }
            }
            return d;
        }
        MoveMap.difference = difference;
    })(MoveMap = Lockboxes.MoveMap || (Lockboxes.MoveMap = {}));
    let State;
    (function (State) {
        State.SOLVED = {
            tile_rows: [
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
            ]
        };
        State.SOLVED_1 = {
            tile_rows: [
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
            ]
        };
        State.SOLVED_2 = {
            tile_rows: [
                [2, 2, 2, 2, 2],
                [2, 2, 2, 2, 2],
                [2, 2, 2, 2, 2],
                [2, 2, 2, 2, 2],
                [2, 2, 2, 2, 2],
            ]
        };
        /**
         * A lockbox is solved if all tiles have the same value
         */
        function isSolved(state) {
            const ref = state.tile_rows[0][0];
            return state.tile_rows.every(r => r.every(t => t == ref));
        }
        State.isSolved = isSolved;
        function equals(a, b) {
            for (let col = 0; col < 5; col++) {
                for (let row = 0; row < 5; row++) {
                    if (a.tile_rows[row][col] != b.tile_rows[row][col])
                        return false;
                }
            }
            return true;
        }
        State.equals = equals;
        function applyMoves(state, move) {
            return {
                tile_rows: state.tile_rows.map((row, row_i) => row.map((tile, col_i) => (tile
                    + MoveMap.get(move, row_i, col_i)
                    + MoveMap.get(move, row_i + 1, col_i)
                    + MoveMap.get(move, row_i - 1, col_i)
                    + MoveMap.get(move, row_i, col_i + 1)
                    + MoveMap.get(move, row_i, col_i - 1)) % 3))
            };
        }
        State.applyMoves = applyMoves;
        function toString(state) {
            return state.tile_rows.map(r => r.join("  ")).join("\n");
        }
        State.toString = toString;
        function generate() {
            return {
                tile_rows: State.SOLVED.tile_rows.map(r => r.map(() => lodash.random(0, 2)))
            };
        }
        State.generate = generate;
        function add(a, b) {
            return {
                tile_rows: a.tile_rows.map((row, row_i) => row.map((tile, col_i) => (tile + b.tile_rows[row_i][col_i]) % 3))
            };
        }
        State.add = add;
        function sub(a, b) {
            return {
                tile_rows: a.tile_rows.map((row, row_i) => row.map((tile, col_i) => (tile - b.tile_rows[row_i][col_i] + 3) % 3))
            };
        }
        State.sub = sub;
    })(State = Lockboxes.State || (Lockboxes.State = {}));
    function basicSolve(state) {
        function chasing(s) {
            let moves = MoveMap.None;
            for (let chased_row = 0; chased_row < 4; chased_row++) {
                const partial = MoveMap.None.map((row, row_i) => {
                    if (row_i == chased_row + 1)
                        return s.tile_rows[chased_row].map(s => (3 - s) % 3);
                    else
                        return row;
                });
                s = State.applyMoves(s, partial);
                moves = MoveMap.chain(moves, partial);
            }
            return [moves, s];
        }
        const [first_chasing_moves, state_after_first_chasing] = chasing(state);
        const B1 = [0, 2, 1][state_after_first_chasing.tile_rows[4][0]]; // If the light at A5 is red then press B1 twice, if it is green press it once.
        const A1B1 = [0, 2, 1][state_after_first_chasing.tile_rows[4][1]]; // If the light at B5 is red then press A1 and B1 twice, if it is green press them once.
        const magic_solve = [
            [A1B1, (A1B1 + B1) % 3, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
        ];
        const state_after_magic_solve = State.applyMoves(state_after_first_chasing, magic_solve);
        const [second_chasing_moves, state_after_second_chasing] = chasing(state_after_magic_solve);
        return MoveMap.chain(first_chasing_moves, magic_solve, second_chasing_moves);
    }
    function solve(state, options = {}) {
        let targets = options?.modulo_targets_allowed ? [State.SOLVED, State.SOLVED_1, State.SOLVED_2] : [State.SOLVED];
        if (options.target_override) {
            targets = targets.map(start => State.add(start, options.target_override));
        }
        let candidate_solutions = targets.map(target => ({
            target: target,
            moves: basicSolve(State.sub(state, target))
        }));
        if (options.minimize)
            candidate_solutions = candidate_solutions.flatMap(s => MoveMap.getEquivalents(s.moves).map(sol => ({ target: s.target, moves: sol })));
        const cost = options.minimize ? (options.minimize_by ?? MoveMap.clickScore) : () => 0;
        return FakeLodash.minBy(candidate_solutions, s => cost(s.moves));
    }
    Lockboxes.solve = solve;
})(Lockboxes || (Lockboxes = {}));
